import type { PointerTable, SchemaPointerTable } from "./types";

export function createSessionTable() {
  return (() => {
    let inputPathTable: PointerTable = {};
    let outputPathTable: PointerTable = {};
    let pathTable: PointerTable = {};
    let schemaTable: SchemaPointerTable = {};

    return {
      setSchemaValue(key: string, value: SchemaPointerTable[string]) {
        schemaTable[key] = value;
      },
      setInputPath(key: string, value: PointerTable[string]) {
        inputPathTable[key] = value;
      },
      setOutputPath(key: string, value: PointerTable[string]) {
        outputPathTable[key] = value;
      },
      setPathValue(key: string, value: PointerTable[string]) {
        pathTable[key] = value;
      },
      getSchemaValue(key: keyof typeof schemaTable) {
        return schemaTable[key];
      },
      getInputPath(key: keyof typeof inputPathTable) {
        return inputPathTable[key];
      },
      getOutputPath(key: keyof typeof outputPathTable) {
        return outputPathTable[key];
      },
      getPathValue(key: keyof typeof pathTable) {
        return pathTable[key];
      },
      resetInputTable() {
        inputPathTable = {};
      },
      // TODO: Add method to reset paths (filters)...
      all() {
        return {
          inputPathTable,
          outputPathTable,
          schemaTable,
          pathTable,
        };
      },
    };
  })();
}
